import { getApiCall, postApiCall } from "../../utils/request";
import { returnErrors } from "../errorAction";
import {
    GET_JOB_TITLES, SEARCH_JOB_TITLE, CHANGE_JOB_TITLE_STATUS, GET_SEARCH_ROLE, GET_ROLE_SKILL, GET_SUGGESTED_SKILLS, IS_EXIST, CLEAR_JOB_TITLES, GET_SEARCH_SKILL, ADD_SKILL_TO_SELECTED_ROLE, REORDER_SKILL, REMOVE_SKILL,
    RENAME_JOB_TITLE, CREATE_JOB_TITLE, REFRESH_SKILLS
} from '../../actionType/type';

export const getJobtitles = () => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/career/list`);
        dispatch({ type: GET_JOB_TITLES, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const searchJobTitle = (val) => async (dispatch) => {
    return dispatch({
        type: SEARCH_JOB_TITLE, payload: val
    });
};

export const changeJobTitleStatus = (id, checked) => async (dispatch) => {
    const obj = {
        _id: id,
    };
    try {
        const response = await postApiCall(`admin/career/toggle`, obj);
        if (response.data.success) {
            dispatch({ type: CHANGE_JOB_TITLE_STATUS, payload: { id, checked } });
            if (!checked) {
                returnErrors(
                    dispatch,
                    "Job Title has been successfully deactivated",
                    200
                );
            }
            else {
                returnErrors(
                    dispatch,
                    "Job Title has been successfully activated",
                    200
                );
            }
        } else {
            returnErrors(
                dispatch,
                response.data.message,
                response.status
            );
        }

    } catch (error) {
        returnErrors(
            dispatch,
            error.response !== undefined && error.response.data.message,
            error.response !== undefined && error.response.status
        );
    }
}

export const searchRole = (val) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/career/search?query=${val}`);
        const data = response.data.data
        dispatch({ type: GET_SEARCH_ROLE, payload: { data, val } });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getRoleSkills = (jobid, jobtitle) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/career/skills?_id=${jobid}`);
        const data = response.data.data[0]
        dispatch({ type: GET_ROLE_SKILL, payload: { data, jobid, jobtitle } });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getSuggestedSkills = (roleId) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/career/search/skill?_id=${roleId}`);
        dispatch({ type: GET_SUGGESTED_SKILLS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const isExist = (query) => async (dispatch) => {
    return dispatch({
        type: IS_EXIST, payload: query
    });
}

export const searchSkills = (val) => async (dispatch) => {
    return dispatch({
        type: GET_SEARCH_SKILL, payload: val
    });
}


export const addSkilltoSelected = (skill) => async (dispatch) => {

    dispatch({
        type: ADD_SKILL_TO_SELECTED_ROLE, payload: skill
    });
    returnErrors(dispatch, `${skill.title} is added to selected skills`, 200)

};

export const reorderSkills = (result) => async (dispatch) => {
    return dispatch({
        type: REORDER_SKILL, payload: result
    });
};

export const removeSkill = (skill) => async (dispatch) => {
    return dispatch({
        type: REMOVE_SKILL, payload: skill
    });
};

export const renameJobTitle = (title) => async (dispatch) => {
    return dispatch({
        type: RENAME_JOB_TITLE, payload: title
    });
};


export const resetData = () => async (dispatch) => {
    return dispatch({
        type: CLEAR_JOB_TITLES
    });
};

export const createJobTitles = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/career/create`, obj);
        if (response.data.success) {
            dispatch({ type: CREATE_JOB_TITLE, payload: response.data.data });
            returnErrors(dispatch, 'Job Title created succesfully', response?.status)
        }
        else {
            returnErrors(dispatch, response?.data.message, response?.status)
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const updatejobTitles = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/career/update`, obj);
        if (response.data.success) {
            dispatch({ type: CREATE_JOB_TITLE, payload: response.data.data });
            returnErrors(dispatch, 'Job Title updated succesfully', response?.status)
        }
        else {
            returnErrors(dispatch, response?.data.message, response?.status)
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const refreshSkills = () => async (dispatch) => {
    return dispatch({
        type: REFRESH_SKILLS
    });
};